export type CategoryUrlSource = {
    c_url?: unknown;
    [key: string]: unknown;
};

/** Matches category PLP path segments (`/c/...`, optional locale prefix). */
const CATEGORY_PLP_PATH = /\/c\/[^/]+/;

export function isCategoryPlpPathname(pathname: string): boolean {
    return CATEGORY_PLP_PATH.test(pathname);
}

export function normalizeCategoryPath(path?: unknown): string | null {
    if (typeof path !== 'string' || !path) {
        return null;
    }

    let pathname = path.trim();

    if (!pathname) {
        return null;
    }

    try {
        pathname = new URL(pathname).pathname;
    } catch {
        pathname = pathname.split(/[?#]/)[0] ?? '';
    }

    pathname = pathname.trim();

    if (!pathname) {
        return null;
    }

    const normalizedPathname = pathname.startsWith('/') ? pathname : `/${pathname}`;
    const withoutSitePrefix = normalizedPathname.replace(/^\/s\/[^/]+(?=\/|$)/, '');

    return withoutSitePrefix.length > 1 ? withoutSitePrefix.replace(/\/+$/g, '') : withoutSitePrefix || '/';
}

export function buildCategoryPathname({ categoryUrl }: { categoryUrl?: unknown }): string {
    const normalizedCategoryUrl = normalizeCategoryPath(categoryUrl);

    if (!normalizedCategoryUrl) {
        return '#';
    }

    return normalizedCategoryUrl;
}

export function createCategoryUrl(category?: CategoryUrlSource | null): string {
    return buildCategoryPathname({
        categoryUrl: category?.c_url,
    });
}
